import { useMutation } from '@tanstack/react-query';
import { answerExercise } from '../../queries/DailySchedule/scheduleContent';

export function useAnswerExercise() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (params: {
      cronogramaId: string;
      exerciseId: string;
      alternativeId: string[];
    }) =>
      answerExercise(
        params.cronogramaId,
        params.exerciseId,
        params.alternativeId
      ),
  });

  return { mutateAsync, isLoading: isPending };
}
